import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { SvgComponent } from 'icon';
import { LinkComponent } from 'link';
import { TranslatePipe } from 'translate';

@Component({
  selector: 'lib-product-box-footer',
  templateUrl: './product-box-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, LinkComponent, SvgComponent, TranslatePipe],
})
export class ProductBoxFooterComponent {
  public showLearnMore = input(true);
  public productCode = input.required<string>();
  public productDetailsLink = input.required<LinkField>();
  public activationFee = input(0);
  public contractDuration = input(0);
}
